import {useRef} from 'react';
import {useSchemasCodelists} from 'schema/hooks/useSchemasCodelists';
import {useMetadataSchemas} from './useMetadataSchemas';

export const useMetadataSchemasCodelists = () => {
  const metadataSchemas = useMetadataSchemas();

  const schemasRef = useRef([
    metadataSchemas.work.schema,
    metadataSchemas.expression.schema,
    metadataSchemas.manifestation.schema,
  ]);

  return useSchemasCodelists(schemasRef.current);
};
